import React from 'react';
import { observer } from 'mobx-react';

import { UiNavLink } from 'shared/uikit';
import { ROUTES } from 'shared/constants';

import { VmNotificationContentPropsType } from '../../types/VmNotificationContentPropsType';

type PropsType = VmNotificationContentPropsType;

export const VmNotificationVacancyCreated = observer(({ notification, onClose }: PropsType) => {
    return (
        <div className={'vm-notification__content'}>
            <div className={'vm-notification__name'}>Новая вакансия</div>
            <div className={'vm-notification__description'}>
                Добавлен новая вакансия <UiNavLink to={ROUTES.VACANCY(notification.data.vacancy.id)} onClick={onClose}>{notification.data.vacancy.name}</UiNavLink>
            </div>
        </div>
    );
});
